import React from "react";

export default function Terms() {
  return (
    <main className="max-w-4xl mx-auto px-6 py-16 text-gray-800 leading-relaxed">
      <h1 className="text-3xl font-bold mb-8 text-center">
        Salgsvilkår for Gjesdalivery
      </h1>

      <section className="space-y-6">
        <p>
          <strong>Gjelder fra:</strong> 26. oktober 2025 <br />
          <strong>Sist oppdatert:</strong> 26. oktober 2025
        </p>

        <h2 className="text-xl font-semibold">1. Parter</h2>
        <p>
          Disse salgsvilkårene gjelder for kjøp av varer og tjenester gjennom{" "}
          <strong>Gjesdalivery.no</strong>, levert av Sandvik Media (org.nr
          933 924 785), heretter kalt <em>Gjesdalivery</em>.
        </p>

        <h2 className="text-xl font-semibold">2. Betaling</h2>
        <p>
          Betaling skjer trygt via Vipps MobilePay ePayment. Du kan betale med
          Vipps, MobilePay eller betalingskort. Alle priser er i NOK og
          inkluderer mva.
        </p>

        <h2 className="text-xl font-semibold">3. Levering</h2>
        <p>
          Levering utføres av Gjesdaliverys sjåfører eller samarbeidspartnere i
          Gjesdal-området. Ved forsinkelser varsles du via SMS eller telefon.
        </p>

        <h2 className="text-xl font-semibold">4. Angrerett</h2>
        <p>
          Angrerett gjelder ikke for mat og ferskvarer, jf. angrerettloven §22.
          For andre varer gjelder 14 dagers angrerett.
        </p>

        <h2 className="text-xl font-semibold">5. Retur og refusjon</h2>
        <p>
          Retur gjelder kun for produkter som ikke er mat eller drikke, og må
          avtales. Ved godkjent retur refunderes kjøpesummen innen 5–10
          virkedager.
        </p>

        <h2 className="text-xl font-semibold">6. Reklamasjon</h2>
        <p>
          Meld fra om skadet eller feil vare så raskt som mulig. Vi tilbyr
          refusjon, erstatning eller ny levering uten ekstra kostnad.
        </p>

        <h2 className="text-xl font-semibold">7. Konfliktløsning</h2>
        <p>
          Tvister søkes løst i minnelighet. Dersom dette ikke lykkes, kan saken
          bringes inn for Forbrukerrådet. Norsk lov gjelder.
        </p>

        <h2 className="text-xl font-semibold">8. Medlemskap og abonnement</h2>
        <p>
          Ved eventuelle medlemskap eller abonnement vil egne vilkår for
          bindingstid, oppsigelse og endring fremgå tydelig.
        </p>

        <h2 className="text-xl font-semibold">9. Kontaktinformasjon</h2>
        <p>
          <strong>Sandvik Media / Gjesdalivery</strong> <br />
          Org.nr: 933 924 785 <br />
          E-post: support@gjesdalivery.no <br />
          Telefon: +47 909 76 011 <br />
          Adresse: Gjesdal, Rogaland, Norge
        </p>

        <h2 className="text-xl font-semibold">10. Personvern</h2>
        <p>
          Vi behandler personopplysninger i samsvar med gjeldende lover.
        </p>
      </section>
    </main>
  );
}
